export const DOUGHNUT_RING_BORDER_COLOR = '#ffffff';

export const DOUGHNUT_RING_BORDER_WIDTH = 2;

export const DOUGHNUT_HOVER_OFFSET = 6;

export const DOUGHNUT_CUTOUT_PERCENT = '58%';

export const DOUGHNUT_ROTATION_DEG = -90;

export const DOUGHNUT_CIRCUMFERENCE = 360;

export const COUNTERPARTY_SIGNAL_CHART_COLORS = {
  trusted: '#C0E7C0',
  suspicious: '#FFE3C2',
  danger: '#FF6D5C',
} as const;

export type CounterpartySignalChartCategory =
  keyof typeof COUNTERPARTY_SIGNAL_CHART_COLORS;

export const TOOLTIP_RISK_ACCENT_COLORS: Record<
  CounterpartySignalChartCategory,
  string
> = {
  trusted: '#00BF59',
  suspicious: '#ff9900',
  danger: '#E64C3C',
};
